import * as moment from 'moment';
import { Injector, Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { languages, storage } from '../utils/catalog';
import { StorageService } from './storage.service';
import { MigrationService } from './migration.service';

@Injectable({
  providedIn: 'root',
})
export class InitService implements OnDestroy {
  private migrationService: MigrationService;
  private storageService: StorageService;
  private translator: TranslateService;
  private langSubscription: Subscription;

  constructor(private injector: Injector) {
    this.migrationService = this.injector.get(MigrationService);
    this.storageService = this.injector.get(StorageService);
    this.translator = this.injector.get(TranslateService);
  }

  private async loadTranslations() {
    const langs = Object.values(languages);

    for (const lang of langs) this.translator.setTranslation(lang, await import(`src/assets/i18n/${lang}.json`));

    this.translator.addLangs(langs);
    moment.locale(this.translator.defaultLang);
    // this.langSubscription = this.translator.onLangChange.subscribe(({ lang }) => {
    //   this.storageService.put(storage.keys.language, lang);
    //   moment.locale(lang);
    // });

    // const lang =
    //   (await this.storageService.get(storage.keys.language)) ||
    //   navigator.language ||
    //   languages.en;

    // this.translator.use(lang.substring(0, 2).toLowerCase());
  }

  public async init() {
    await this.migrationService.init();
    await this.loadTranslations();
  }

  public ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
  }
}
